// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import { z } from 'zod';

import { EnvironmentIdSchema } from '../id';

export const ApiSourceOfTruthPublishRequestSchema = z.object({
  environmentGuid: EnvironmentIdSchema,
  updateSotRulesInGlobalJs: z.boolean(), // Anyone
  updateConsentConfigurationInGlobalJs: z.boolean(), // Anyone
  updateClientConfigInGlobalJs: z.boolean(), // Admin
  publishTestFiles: z.boolean().optional(), // Anyone
});

export type ApiSourceOfTruthPublishRequest = z.infer<typeof ApiSourceOfTruthPublishRequestSchema>;

export const ApiSourceOfTruthPublishResponseSchema = z
  .object({
    areGlobalRulesPublished: z.boolean().optional(),
    publishedPageRulesCount: z.number().optional(),
    totalPageRulesCount: z.number().optional(),
    input: ApiSourceOfTruthPublishRequestSchema,
    status: z.union([z.literal('INITIATED'), z.literal('COMPLETED'), z.literal('FAILED')]),
    initializeTimeStamp: z.string(),
  })
  .transform((data) => {
    const date = moment(data.initializeTimeStamp);

    const finalObj = {
      date,
      isFailed: false,
      isPending: false,
      inProgress: false,
      isComplete: false,
      global: {
        available: false,
        isComplete: false,
        inProgress: false,
        isPending: false, // same as above
      },
    };

    switch (data.status) {
      case 'INITIATED':
        if (finalObj.global.available) {
          if (data.areGlobalRulesPublished !== undefined) {
            if (data.areGlobalRulesPublished) {
              finalObj.global.isComplete = true;
            } else {
              finalObj.global.inProgress = true;
            }
          } else {
            finalObj.global.isPending = true;
          }
        }

        if (finalObj.global.inProgress || finalObj.global.isComplete) {
          finalObj.inProgress = true;
        } else {
          finalObj.isPending = true;
        }
        break;
      case 'COMPLETED':
        finalObj.isComplete = true;
        if (finalObj.global.available) finalObj.global.isComplete = true;
        break;
      case 'FAILED':
        finalObj.isFailed = true;
        break;
    }

    return finalObj;
  });

export type ApiSourceOfTruthPublishResponse = z.infer<typeof ApiSourceOfTruthPublishResponseSchema>;
